module.exports = __webpack_public_path__ + "static/media/Julian_Love_INT.9b5e7460.mp4";